import { Config } from '@/config';
import { ApiService } from '@/services/api.service';

class AnnotationsService {
  getOpportunityDocumentAnnotations({ opportunityId, cancelToken = null }) {
    return ApiService.get(`${Config.api.document.url}api/v1/opportunities/${opportunityId}/documents/annotations`, {
      cancelToken: cancelToken && cancelToken.token,
    }).then((response) => response.data);
  }

  addDocumentAnnotation({ opportunityId, docId, selection }) {
    return ApiService.post(
      `${Config.api.document.url}api/v1/opportunities/${opportunityId}/documents/${docId}/annotations`,
      {
        startXPath: selection.startXPath,
        startOffset: selection.startOffset,
        endXPath: selection.endXPath,
        endOffset: selection.endOffset,
        startPage: selection.startPage,
        endPage: selection.endPage,
        text: selection.text,
        colorCode: selection.colorCode,
      },
    ).then((response) => response.data);
  }

  updateDocumentAnnotation({ opportunityId, docId, id, payload }) {
    return ApiService.put(
      `${Config.api.document.url}api/v1/opportunities/${opportunityId}/documents/${docId}/annotations/${id}`,
      payload,
    ).then((response) => response.data);
  }

  deleteDocumentAnnotation({ opportunityId, docId, id }) {
    return ApiService.delete(
      `${Config.api.document.url}api/v1/opportunities/${opportunityId}/documents/${docId}/annotations/${id}`,
    ).then((response) => response.data);
  }
}

export const annotationsService = new AnnotationsService();
